module.exports = __webpack_public_path__ + "img/notif-check.c86be0e4.svg";